import { useQuery } from 'react-query'
import Loader from 'components/general/Loader'
import ScoresLiveCard from "components/common/ScoresLiveCard";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { dateToday, dateFormat } from "helpers/utils";
import { getTodayMatches } from "data/Querys";
import NotAvailable from "components/common/NotAvailable";

//Generic
import { CardsLayout as CardsLayoutGeneric } from "components/sports/glo/todayMatches/generic";

//Sports
import { CardsLayout as CardsLayoutTte } from "components/sports/glo/todayMatches/tte";


const getCardsLayout = (discipline) => {
    switch (discipline) {
        case 'TTE':
            return CardsLayoutTte
        default:
            return CardsLayoutGeneric
    }
}

const TodayMatches = (props) => {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_date } = useUrlFriendlyToParameters()
    // load getting ready or running units
    let date = dateFormat(mirs_date) === "Invalid date" ? dateToday() : dateFormat(mirs_date)
    const { data, isError, isLoading } = useQuery(
        {
            //queryKey: ['todayMatches', mirs_competition, mirs_language, mirs_discipline, dateToday()],
            queryKey: ['todayMatches', mirs_competition, mirs_language, mirs_discipline, date],
            queryFn: getTodayMatches,
            refetchInterval: 0,
            cacheTime: 5000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );
    if (isError) { return <NotAvailable /> }
    if (isLoading) { return <Loader />; }

    let results = data?.filter(res => res.result)

    results = props.type === 'T'
        ? results?.filter(res => res?.eventUnit?.code?.includes('TEAM'))
        : results = props.type === 'A'
            ? results?.filter(res => !res?.eventUnit?.code?.includes('TEAM'))
            : results;

if (!results || results.length === 0) { return <NotAvailable /> }

const CardsLayout = getCardsLayout(mirs_discipline)

return (<>
    <CardsLayout results={results} />
</>
);
}

export default TodayMatches;